import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  let aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>
        {htmlToReactParser.parse(
          xss(
            props.waitingArea && props.waitingArea.name
              ? APP.LANGUAGE.WaitingAreaManageUsers.InfoPartOne.replace('##waitingAreaName##', props.waitingArea.name)
              : ''
          )
        )}
      </p>
    </div>
  );
  let options = [
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  let activeIndexOfPage = window.localStorage.getItem(`waUsersActiveIndex-${props.userId}`);
  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="waUsersActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
